import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DateFormatHelperService {

  constructor() { }
  public GetDisplayDateOnly(date: Date | string) {
    if (date ==  "")
      return "";
    const parsedDate = new Date(date);
    if (parsedDate.getFullYear() == 1)
      return "";
    return parsedDate.toLocaleDateString('en-GB');
  }

  public GetDisplayDate(date: Date | string, includeSeconds: boolean = false) {
    if (date ==  "")
      return "";
    const parsedDate = new Date(date);
    if (parsedDate.getFullYear() == 1)
      return "";

    let formattedDate = parsedDate.toLocaleDateString('en-GB') + " " + (new Date(date)).toLocaleTimeString();
    return includeSeconds ? formattedDate : formattedDate.replace(/:\d{2}$/, '');
  }

  public StripTimeFromDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  
  public GetAPIFormat(date: Date): string
  {
    if (date == null)
      return "";

    let year: string | number = date.getFullYear(),
      month: string | number  = date.getMonth() + 1,
      day: string | number  = date.getDate(),
      hours: string | number  = date.getHours(),
      min: string | number  = date.getMinutes(),
      sec: string | number  = date.getSeconds();

      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hours = hours < 10 ? "0" + hours : hours;
      min = min < 10 ? "0" + min : min;
      sec = sec < 10 ? "0" + sec : sec;

      return `${year}-${month}-${day}T${hours}:${min}:${sec}.0000000`;

  }
}
